import utils from '@/utils/util'

/***
 * ios WebViewJavascriptBridge 交互方法
 */
function setupWebViewJavascriptBridge (callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge)
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    let WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe)
    }, 0)
}

/***
 * Android JsBridge 交互方法
 */

function connectWebViewJavascriptBridge (callback) { 
    if (window.WebViewJavascriptBridge) {
          callback(WebViewJavascriptBridge)
    } else {
          document.addEventListener(
              'WebViewJavascriptBridgeReady'
               , function() {
                    callback(WebViewJavascriptBridge)
               },
               false
          );
    }
}


export default {
    callhandler (name, data, callback) {
        switch (utils.os()) {
            case 'iosApp':
                setupWebViewJavascriptBridge(function (bridge) {
                    bridge.callHandler(name, data, callback)
                })
                break;
        
            case 'androidApp':
                connectWebViewJavascriptBridge (function(bridge) {
                    bridge.callHandler(name, data, callback)
                })
                break;
        }
       
    },
    registerhandler (name, callback) {
        switch (utils.os()) {
            case 'iosApp':
                setupWebViewJavascriptBridge(function (bridge) {
                    bridge.registerHandler(name, function (data, responseCallback) {
                        callback(data, responseCallback)
                    })
                })
                break;
        
            case 'androidApp':
                connectWebViewJavascriptBridge (function(bridge) {
                    bridge.registerHandler(name, function (data, responseCallback) {
                        callback(data, responseCallback)
                    })
                })
                break;
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/bridge/index.js